import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { debounceTime, Subject, takeUntil } from 'rxjs';
import { CommonDataSharingService } from '../../../../../src/app/shared/services/common-data-sharing.service';
import { _clone } from '../../../../../src/app/utils/constants';
import { ICONS } from '../../../utils/svg-icons';
import { SafeHtmlPipe } from '../../validators/safe-html.pipe';

@Component({
  selector: 'app-filter-model',
  templateUrl: './filter-model.component.html',
  styleUrl: './filter-model.component.scss',
  imports: [CommonModule, BsDatepickerModule, ReactiveFormsModule, FormsModule, InfiniteScrollModule, NgxSliderModule, SafeHtmlPipe],
})
export class FilterModelComponent implements OnInit {
  @Input() filtersList: any;
  @Input() appliedFilters: any;
  @Input() appliedDateFilters: any;
  @Input() appliedRadioFilters: any;

  searchContent: any;
  selectedFilterIndex: number = 0;
  selectedFilters: any = [];
  selectedDateFilters: any = { from: null, to: null };
  selectedFiltersRadio: any = [];

  page = 1;
  elementPage = 1;
  value: number = 50;
  highValue: number = 5000;
  options: any = {
    floor: 50,
    ceil: 5000,
  };
  clear = false;
  today = new Date();
  @Input() range: any;

  sliderValueChange = false;
  private searchTermChanged: Subject<string> = new Subject<string>();
  private destroy$: Subject<void> = new Subject<void>();
  ICONS = ICONS;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private _activeModal: NgbActiveModal,
    private _commonDataService: CommonDataSharingService,
  ) {
    this.searchTermChanged.pipe(debounceTime(500), takeUntil(this.destroy$)).subscribe((newValue) => {
      this.getSportsList();
    });
  }

  ngOnInit(): void {
    this.selectedFilters = Array.isArray(this.appliedFilters) ? _clone(this.appliedFilters) : this.appliedFilters;
    this.appliedFilters = Array.isArray(this.appliedFilters) ? _clone(this.appliedFilters) : this.appliedFilters;
    this.selectedFiltersRadio = Array.isArray(this.appliedRadioFilters) ? _clone(this.appliedRadioFilters) : this.appliedRadioFilters;
    this.appliedRadioFilters = Array.isArray(this.appliedRadioFilters) ? _clone(this.appliedRadioFilters) : this.appliedRadioFilters;
    if (this.selectedFiltersRadio == undefined) {
      this.selectedFiltersRadio = [];
      this.appliedRadioFilters = [];
    }
    if (this.selectedFilters == undefined) {
      this.selectedFilters = [];
      this.appliedFilters = [];
    }
    if (this.appliedDateFilters && this.appliedDateFilters.from && this.appliedDateFilters.to)
      this.selectedDateFilters = { from: new Date(this.appliedDateFilters.from), to: new Date(this.appliedDateFilters.to) };
    else this.appliedDateFilters = _clone(this.selectedDateFilters);
    if (this.range && this.range?.min && this.range?.min != null && this.range?.min != undefined) {
      this.value = this.range?.min;
      this.highValue = this.range?.max;
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getSportsList() {
    this._commonDataService._getSportList(this.searchContent, 1).subscribe(
      (sports: any) => {
        // this.sportList = sports; // Use the data as needed
        this.filtersList[this.selectedFilterIndex].children = sports.map((data: any) => ({ id: data.id, name: data.name, sId: data.id }));
        this.changeDetectorRef.detectChanges();
      },
      (error: any) => {
        console.error('Error fetching sports list:', error);
      },
    );
  }

  onSelectFilter(filter: any): void {
    if (this.selectedFilters.indexOf(filter.id) != -1) {
      this.selectedFilters = this.selectedFilters.filter((x: any) => x != filter.id);
    } else {
      this.selectedFilters.push(filter.id);
    }
  }
  onSelectRadioFilter(filter: any): void {
    this.selectedFiltersRadio = [];
    this.selectedFiltersRadio.push(filter.id);
  }
  onClose(selectedFilters?: any): void {
    this._activeModal.close(selectedFilters);
  }

  onChangeDate(dateType: any) {
    if (dateType == 'from' && this.selectedDateFilters.to && this.selectedDateFilters.to < this.selectedDateFilters.from) {
      this.selectedDateFilters['to'] = null;
    }
  }

  onApply(): void {
    const selectedFilters = this.findDatesFilter
      ? {
          selectedFiltersRadio: this.selectedFiltersRadio,
          selectedFilters: this.selectedFilters,
          selectedDates: !this.selectedDateFilters.to && this.selectedDateFilters.from ? this.appliedDateFilters : this.selectedDateFilters,
          range: { min: this.value, max: this.highValue, clear: this.clear },
        }
      : {
          selectedFilters: this.selectedFilters,
          selectedFiltersRadio: this.selectedFiltersRadio,
          range: { min: this.value, max: this.highValue, clear: this.clear },
        };
    this.onClose(selectedFilters);
  }

  onClearAll(): void {
    this.selectedDateFilters = { from: null, to: null };
    this.selectedFilters = [];
    this.selectedFiltersRadio = [];
    this.value = 50;
    this.highValue = 5000;
    this.clear = true;
  }

  compareArrays = () => {
    const selectedSorted = this.selectedFilters;
    const appliedSorted = this.appliedFilters;
    // }
    const selectedSortedRadio = this.selectedFiltersRadio;
    const appliedSortedRadio = this.appliedRadioFilters;
    if (this.clear) {
      return false;
    }
    if ((this.value != this.range?.min || this.highValue != this.range?.max) && this.sliderValueChange) {
      return false;
    }
    if (this.appliedDateFilters || this.findDatesFilter)
      return (
        JSON.stringify(selectedSorted) === JSON.stringify(appliedSorted) &&
        JSON.stringify(selectedSortedRadio) === JSON.stringify(appliedSortedRadio) &&
        (JSON.stringify(this.appliedDateFilters) === JSON.stringify(this.selectedDateFilters) ||
          (this.selectedDateFilters.from && !this.selectedDateFilters.to))
      );

    return (
      JSON.stringify(selectedSorted) === JSON.stringify(appliedSorted) && JSON.stringify(selectedSortedRadio) === JSON.stringify(appliedSortedRadio)
    );
  };

  get findDatesFilter(): any {
    return this.filtersList.find((x: any) => x.type == 'dateRange');
  }
  // search
  onSearchUser(isEnterKey: boolean, value: any): void {
    if (this.searchContent === '') {
      this.searchTermChanged.next(''); // Clear search if input is empty
      return;
    }

    if (isEnterKey || this.searchContent.trim().length > 0) {
      this.searchTermChanged.next(this.searchContent.trim()); // Trim leading and trailing spaces
    }
  }
  disableKeyPress(event: KeyboardEvent): void {
    event.preventDefault();
  }
  onScroll(e: any, value: any) {
    if (this.filtersList[this.selectedFilterIndex].name == 'Sports') {
      this.page = this.page + 1;
      this._commonDataService._getSportList(this.searchContent, this.page).subscribe(
        (sports: any) => {
          if (sports) {
            // this.sportList = sports; // Use the data as needed
            if (sports.length < 0) {
              this.page = this.page - 1;
            }
            sports.map((data: any) => {
              this.filtersList[this.selectedFilterIndex].children.push({ id: data.id, name: data.name, sId: data.id });
            });
            this.changeDetectorRef.detectChanges();
          }
        },
        (error: any) => {
          console.error('Error fetching sports list:', error);
        },
      );
    }
  }
  valueChange() {
    this.sliderValueChange = true;
  }
}
